import React from 'react'
import './CommonTroubleShooting.scss'
import Property from '@episerver/spa-core/Components/Property';
import { isBrowser } from "react-device-detect";
import { Container, Row } from 'reactstrap';

export default function CommonTroubleShooting ({ context, iContent }) {
    
    return(
        <Container className="common-trouble-shooting">
            <Row className="rowOptions">
                <div className="blueBorder"></div>
                <Property context={context} iContent={iContent} field="commonTroubleShootingArea" />
                {isBrowser ? <div style={{position: 'absolute', left: '0', marginLeft: '15px'}}><Property context={context} iContent={iContent} field="plusArea" /></div> : null }
            </Row>
        </Container>
    )
}